var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('EventsHeader'),_c('EventsIntro'),_c('EventsIndex'),_c('EventsMore'),_c('NavigationCta')],1)}
var staticRenderFns = []

export { render, staticRenderFns }